import React from 'react';
import { cn } from './cn';

export type TopBarProps = {
  left?: React.ReactNode;
  title?: React.ReactNode;
  right?: React.ReactNode;
  className?: string;
};

export function TopBar({ left, title, right, className }: TopBarProps) {
  return (
    <header
      className={cn(
        'sticky top-0 z-40 safe-top',
        'border-b border-surface-border',
        'bg-surface-card/40 backdrop-blur-xl',
        className,
      )}
    >
      <div className="flex h-12 items-center justify-between px-4">
        <div className="flex min-w-0 flex-1 items-center gap-2">{left}</div>
        <div className="min-w-0 flex-[2] text-center">
          {title ? (
            <h1 className="truncate text-sm font-semibold text-text-primary">{title}</h1>
          ) : (
            <span />
          )}
        </div>
        <div className="flex min-w-0 flex-1 items-center justify-end gap-2">{right}</div>
      </div>
    </header>
  );
}

